'use client';

import {memo, useRef, useContext} from 'react';

import CSS from './CookieConsent.module.scss';
import Button from '@/components/elements/Button';
import {temporalStyle} from '@/lib/utils';
import {SettingContext} from '@/context/Setting';

export default memo(
  function CookieConsent() {
    const [{cookieConsent: consent}, setSetting] = useContext(SettingContext)!;
    const ref = useRef<HTMLDivElement>(null);

    return consent.showWarning ? (
      <div ref={ref} className={CSS.cookieConsent}>
        بیت‌یک برای عملکرد بهتر از کوکی استفاده می‌کنه
        <Button
          onClick={() =>
            temporalStyle(ref, CSS.hide, 1e3, () =>
              setSetting(state => ({
                ...state,
                cookieConsent: {showWarning: false, googleAnalytics: true}
              }))
            )
          }>
          باشه
        </Button>
      </div>
    ) : null;
  },
  () => true
);
